import {
    apiRequest,
    daftarpegawai,
    addpegawaitolist,
    daftarpangkat,
    detailpegawai,
    PromotionPeriodDetail,
    ListPresensi,
    CancelPresensi,
    GeneratePresensi,
    UpdateJabatan,
    ListJabatan,
    flagRev
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", addpegawaitolist, {
            body: query
        }, true)
    }
    fetchFlagRev = async (query) => {
        return await apiRequest("post", flagRev, {
            body: query
        }, true)
    }
    fetchdetailPegawaiChannel = async (query) => {
        return await apiRequest("get", detailpegawai, {
            params: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", daftarpegawai, {
            params: query
        }, true)
    }
    fetchRank = async (query) => {
        return await apiRequest("get", daftarpangkat, {
            params: query
        }, true)
    }
    
    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListPresensi = async (query, cancelToken) => {
        return await apiRequest("get", ListPresensi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDeletePresensi = async (query, cancelToken) => {
        return await apiRequest("get", CancelPresensi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchGeneratePresensi = async (query, cancelToken) => {
        return await apiRequest("get", GeneratePresensi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchUpdateJabatan = async (query, cancelToken) => {
        return await apiRequest("get", UpdateJabatan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchListJabatan = async (query, cancelToken) => {
        return await apiRequest("get", ListJabatan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default CreateRepository